module.exports = __webpack_public_path__ + "static/media/Ethnicity_Donut.307e1b91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Ethnicity_Donut.svg
// module id = 360
// module chunks = 0